import { membersStore } from "../membersStore"

export const useMembersStore = () => {
  const members = membersStore((state) => state.members)
  const invitations = membersStore((state) => state.invitations)
  const loading = membersStore((state) => state.loading)
  const error = membersStore((state) => state.error)
  const pageInfo = membersStore((state) => state.pageInfo)

  const getMembers = membersStore((state) => state.getMembers)
  const getInvitations = membersStore((state) => state.getInvitations)
  const reset = membersStore((state) => state.reset)

  return {
    members,
    invitations,
    loading,
    error,
    pageInfo,
    getMembers,
    getInvitations,
    reset,
  }
}

export default useMembersStore
